module.exports = __webpack_public_path__ + "20ba16bef4c5d5d0dd5c98ea6ed2454d.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-ultralight.eot
// module id = 26
// module chunks = 0